---
date: 2022-02-19
title: Indoor areas at zoom 16
---

Indoor areas are now displayed starting at zoom 16. Give it a try!
